export default "__VITE_ASSET__5a7986a1__"